import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CMG, ComboBox, Lider } from '../../../shared/models/cmg.model';
import { CmgService } from '../../../shared/services/cmg.service';
import { UsersService } from '../../../shared/services/users.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class CmgFormComponent implements OnInit {

  editCMG: CMG;
  usersList: any = [];
  liderList: any[] = [];
  buyerList: any[] = [];
  correos: any;
  correosBuyer: any;
  departmentCBX: ComboBox;
  categoryCBX: ComboBox;
  subCategoryCBX: ComboBox;
  editMode: boolean = false;
  constructor(
    private usersService: UsersService,
    private route: ActivatedRoute,
    private router: Router,
    private cmgService: CmgService,
    ) { }

  async ngOnInit() {
    this.usersService.getCompanyAdminUsers('CAylZM8FSnRSHux8Vbzy').subscribe(users => {
    // this.usersService.getAllUsers().subscribe(users => {
      this.usersList = users.sort((a,b) => a.name < b.name ? (a === b) ? 0 : -1 : 1);
      this.correos = this.usersList.filter(user => this.liderList.includes(user.id));
      this.correosBuyer = this.usersList.filter(user => this.buyerList.includes(user.id));
    });
    this.editCMG = new CMG;
    if (this.route.snapshot.params['id']) {
      this.editMode = true;
      this.getEditCMG(this.route.snapshot.params['id']);
      this.getLiderList(this.route.snapshot.params['id']);
      this.getBuyerList(this.route.snapshot.params['id']);
    }
    this.getDepartment();
    this.getCategory();
  }
  setLiderValue(e){
    this.correos = this.usersList.filter(user => this.liderList.includes(user.id));
  }
  setBuyerValue(e){
    this.correosBuyer = this.usersList.filter(user => this.buyerList.includes(user.id));
  }
  getEditCMG(cmgId: number){
    this.cmgService.getEditCMG(cmgId).subscribe(res =>{
      this.editCMG = res.data[0];
    });
  }
  getLiderList(cmgId: number){
    this.cmgService.getLiderList(cmgId).subscribe(res =>{
      this.liderList = res;
    });
  }
  getBuyerList(cmgId: number){
    this.cmgService.getBuyerList(cmgId).subscribe(res =>{
      this.buyerList = res;
    });
  }
  getDepartment(){
    this.cmgService.getDepartment().subscribe(res =>{
      this.departmentCBX = res.data;
    });
  }
  getCategory(){
    this.cmgService.getCategory().subscribe(res =>{
      this.categoryCBX = res.data;
    });
  }

  saveCMG(data){
    if (data.validationGroup.validate().isValid) {
      // this.cmgService.
      this.cmgService.saveCMG(this.editCMG,this.liderList,this.buyerList).subscribe(res => {
        this.router.navigate(['/dash/cmg']);
      })
    }
  }
}
